export default {
  InputEmpty: "الرجاء إدخال {name}",
} as const;
